import { SubjectType, type Subject } from '../../../graphql/lo1/generated';

export const getSubjectHash = (subject: Subject): string =>
  subject.subjectType === SubjectType.Child ? (subject.childSubject?.childId ?? '') : subject.subjectType;
